import {
  REFUND_AMOUNT,
  RETRIEVE_TRANSACTIONS,
  RETRIEVE_RENTER_TRANSACTIONS
} from "../actions/types";
  
  const initialState = { transactions : [], totalTransactionCount : 0 };

const transactionReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_TRANSACTIONS:
      return {
        transactions: payload.rows,
        totalTransactionCount: payload.count,
      };

    case RETRIEVE_RENTER_TRANSACTIONS:
      return {
        transactions: payload.rows,
        totalTransactionCount: payload.count,
      };

    case REFUND_AMOUNT:
      return {
        transactions: payload.rows,
        totalTransactionCount: payload.count,
      };
      
    default:
      return state;
  }
};

export default transactionReducer;